import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgChartsModule } from 'ng2-charts';
import { Chart, registerables } from 'chart.js';

import { AppComponent } from './app.component';
import { PopupCardComponent } from './popup-card/popup-card.component';
import { SparklineChartComponent } from './sparkline-chart/sparkline-chart.component';
import { SolarChartComponent } from './solar-chart/solar-chart.component';
import { GlobalErrorHandler } from './error-log.service';
import { COMMIT_HASH } from '../version';

Chart.register(...registerables);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${COMMIT_HASH}`);
}

@NgModule({
  declarations: [
    AppComponent,
    PopupCardComponent,
    SparklineChartComponent,
    SolarChartComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    AgGridModule,
    NgChartsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
